import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.panelTarget.hidden = !this.open
  }

  get open() {
    throw new Error("disclosure-base: define `open` in the controller that extends it")
  }
}
